/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Modal_Preview_LabelInputs */

const en_position_modal_preview_label = /** @type {(inputs: Position_Modal_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview:`)
};

const fr_position_modal_preview_label = /** @type {(inputs: Position_Modal_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apercu :`)
};

const de_position_modal_preview_label = /** @type {(inputs: Position_Modal_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau:`)
};

const it_position_modal_preview_label = /** @type {(inputs: Position_Modal_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima:`)
};

const ru_position_modal_preview_label = /** @type {(inputs: Position_Modal_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр:`)
};

const es_position_modal_preview_label = /** @type {(inputs: Position_Modal_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avance:`)
};

const zh_cn2_position_modal_preview_label = /** @type {(inputs: Position_Modal_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览：`)
};

const ja_position_modal_preview_label = /** @type {(inputs: Position_Modal_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビュー:`)
};

const hi_position_modal_preview_label = /** @type {(inputs: Position_Modal_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्व दर्शन:`)
};

const pt_pt2_position_modal_preview_label = /** @type {(inputs: Position_Modal_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização:`)
};

/**
* | output |
* | --- |
* | "Preview:" |
*
* @param {Position_Modal_Preview_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_preview_label = /** @type {((inputs?: Position_Modal_Preview_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_Preview_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_modal_preview_label(inputs)
	if (locale === "de") return de_position_modal_preview_label(inputs)
	if (locale === "it") return it_position_modal_preview_label(inputs)
	if (locale === "ru") return ru_position_modal_preview_label(inputs)
	if (locale === "es") return es_position_modal_preview_label(inputs)
	if (locale === "zh-CN") return zh_cn2_position_modal_preview_label(inputs)
	if (locale === "ja") return ja_position_modal_preview_label(inputs)
	if (locale === "hi") return hi_position_modal_preview_label(inputs)
	if (locale === "pt-PT") return pt_pt2_position_modal_preview_label(inputs)
	return en_position_modal_preview_label(inputs)
});